import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FormlyErrorComponent } from '../formly-error.component';
import { FieldLabelRowComponent } from './field-label-row.component';
import { FormlyDataCyDirective } from '../../directives/formly-data-cy.directive';

@Component({
  selector: 'formly-field-custom-password',
  template: `
    <!--
      Width classes from field.className are already applied by formly to the host
      <formly-field>. Re-applying them here compounded them (a half-width field rendered at
      50% of 50%); the inner field just fills its host.
    -->
    <mat-form-field
      class="dd-compact-field w-full"
      [class.mat-form-field-invalid]="formControl.invalid && formControl.touched">
      <mat-label>
        <app-field-label-row [label]="props.label" [required]="props.required" [info]="props.info"></app-field-label-row>
      </mat-label>
      <input
        matInput
        type="password"
        [required]="props.required"
        [disabled]="props.disabled"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [formlyDataCy]="field" />
      @if (props.description) {
        <mat-hint>{{ props.description }}</mat-hint>
      }
    </mat-form-field>
    <app-formly-error [field]="field"></app-formly-error>
  `,
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    MatInputModule,
    FormlyErrorComponent,
    FormlyDataCyDirective,
    FieldLabelRowComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyPasswordType extends FieldType {}
